import { useEffect, useState } from "react";
import { geo } from "../../lib/api";
import { useLang } from "../../context/LangContext";
import { Badge } from "../../components/ui/badge";
import { Navigation } from "lucide-react";

const FALLBACK = [
  { code: "AK", name: "Akko", squares: 42, color: "#FF6B35" },
  { code: "AS", name: "Asqelon", squares: 38, color: "#34C759" },
  { code: "AZ", name: "Azz", squares: 28, color: "#FFD60A" },
  { code: "BS", name: "Be'er Sheva", squares: 88, color: "#FF453A" },
  { code: "HF", name: "Haifa", squares: 52, color: "#5856D6" },
  { code: "JM", name: "Jerusalem", squares: 64, color: "#AF52DE" },
  { code: "TA", name: "Tel Aviv", squares: 30, color: "#007AFF" },
  { code: "ZF", name: "Tzfat", squares: 46, color: "#FF9F0A" },
];

export default function RouteView() {
  const { t } = useLang();
  const [districts, setDistricts] = useState(FALLBACK);

  useEffect(() => {
    geo
      .districts()
      .then((d) => {
        if (Array.isArray(d) && d.length) setDistricts(d);
      })
      .catch(() => {});
  }, []);

  return (
    <div className="px-4 pt-6 pb-6 space-y-5" data-testid="route-view">
      <div>
        <h1 className="font-display text-3xl font-bold tracking-tight">
          {t("app.tab_route")}
        </h1>
        <p className="text-white/45 text-sm">{t("app.route_subtitle")}</p>
      </div>

      <div className="ios-card p-5 flex items-center gap-4">
        <div className="h-12 w-12 rounded-2xl bg-[#007AFF]/15 border border-[#007AFF]/30 flex items-center justify-center">
          <Navigation className="h-5 w-5 text-[#007AFF]" />
        </div>
        <div>
          <p className="font-semibold">{t("app.route_card_title")}</p>
          <p className="text-xs text-white/50">{t("app.route_card_text")}</p>
        </div>
      </div>

      <p className="text-[10px] text-white/50 uppercase tracking-wider font-semibold pt-2">
        {t("app.route_districts_label")}
      </p>

      <div className="space-y-2">
        {districts.map((d) => (
          <div
            key={d.code}
            data-testid={`route-district-${d.code}`}
            className="ios-card p-4 flex items-center gap-4 cursor-pointer hover:border-white/15 transition-colors"
          >
            <div
              className="h-10 w-10 rounded-xl flex items-center justify-center font-mono font-bold text-sm"
              style={{
                backgroundColor: `${d.color || "#007AFF"}20`,
                color: d.color || "#007AFF",
                border: `1px solid ${d.color || "#007AFF"}40`,
              }}
            >
              {d.code}
            </div>
            <div className="flex-1">
              <p className="font-semibold">{d.name}</p>
              <p className="text-xs text-white/45">
                ~{d.squares || "?"} {t("app.route_active_squares")}
              </p>
            </div>
            <Badge className="bg-white/5 text-white/70 border-white/10">
              {d.code}
            </Badge>
          </div>
        ))}
      </div>
    </div>
  );
}
